export const vTooltip = {
  bind (el, binding) {
    const getText = () => typeof binding.value === 'string' ? binding.value : binding.value && binding.value.content || ''
    const placement = () => typeof binding.value === 'object' && binding.value.placement || 'top'

    let tip = null
    const show = () => {
      const text = getText()
      if (!text) return
      tip = document.createElement('div')
      tip.className = 'vtip__box'
      tip.textContent = text
      document.body.appendChild(tip)
      position()
      requestAnimationFrame(() => tip && (tip.style.opacity = '1'))
    }
    const hide = () => { if (!tip) return; tip.style.opacity = '0'; setTimeout(() => tip && tip.remove(), 120); tip = null }
    const position = () => {
      if (!tip) return
      const rect = el.getBoundingClientRect()
      const tr = tip.getBoundingClientRect()
      const p = placement()
      const gap = 8
      let x = 0, y = 0
      if (p === 'top') { y = rect.top - tr.height - gap; x = rect.left + rect.width / 2 - tr.width / 2 }
      if (p === 'bottom') { y = rect.bottom + gap; x = rect.left + rect.width / 2 - tr.width / 2 }
      if (p === 'left') { x = rect.left - tr.width - gap; y = rect.top + rect.height / 2 - tr.height / 2 }
      if (p === 'right') { x = rect.right + gap; y = rect.top + rect.height / 2 - tr.height / 2 }
      tip.style.left = `${Math.max(4, Math.min(x, window.innerWidth - tr.width - 4))  }px`
      tip.style.top = `${Math.max(4, Math.min(y, window.innerHeight - tr.height - 4))  }px`
    }

    el.addEventListener('mouseenter', show)
    el.addEventListener('mouseleave', hide)
    el.addEventListener('focus', show)
    el.addEventListener('blur', hide)
    window.addEventListener('scroll', position, true)

    el.__vtipCleanup = () => {
      el.removeEventListener('mouseenter', show)
      el.removeEventListener('mouseleave', hide)
      el.removeEventListener('focus', show)
      el.removeEventListener('blur', hide)
      window.removeEventListener('scroll', position, true)
    }
  },
  unbind (el) { el.__vtipCleanup && el.__vtipCleanup() }
}

const style = document.createElement('style')
style.textContent = `
.vtip__box { position: fixed; pointer-events: none; opacity: 0; transition: opacity .12s ease; z-index: 9999;
  background: var(--tooltip-bg, rgba(28,28,30,0.98));
  color: var(--tooltip-color, #fff);
  border: 1px solid var(--tooltip-border, rgba(255,255,255,0.08));
  font-size: 12px; line-height: 1.2; padding: 6px 8px; border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0,0,0,.18); }
`
document.head.appendChild(style)
